/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type InsertFrameworkMutationVariables = Types.Exact<{
  input_payload: Types.Frameworks_Insert_Input;
}>;

export type InsertFrameworkMutation = {
  __typename?: 'mutation_root';
  insert_frameworks_one?: { __typename?: 'frameworks'; id: string } | null;
};

export const InsertFrameworkDocument = `
    mutation InsertFramework($input_payload: frameworks_insert_input!) {
  insert_frameworks_one(object: $input_payload) {
    id
  }
}
    ` as string & TypedDocumentNode<InsertFrameworkMutation, InsertFrameworkMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    InsertFramework: build.mutation<InsertFrameworkMutation, InsertFrameworkMutationVariables>({
      query: (variables) => ({ document: InsertFrameworkDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useInsertFrameworkMutation } = injectedRtkApi;
